/**
 * @author PengWen
 * @description 登录实时人数管理
 * @Date 2023/06/21
 */
import React from 'react'
import {component_tool, framework_tool ,utils_tool} from '../../../tool';
let {WizModal} = component_tool;
let { $$ } = utils_tool;

let componentName = 'AuthLoginLogDetail'

const columns = [
    {
        name: "id",
        fromItem: {
          type: "hidden"
        }
    },
    {
      title:"账号",
      name:"userName",
      searchItem: {},
      tableItem: {
          width: 150
      },
    },
    {
      title:"登陆时间",
      name:"loginTime",
      tableItem: {
          width: 200
      },
    },
    {
      title:"平台",
      name:"platform",
      searchItem: {
        type: "select"
      },
      tableItem: {
          width: 150
      },
      dict: [
        { code: 3, codeName: "PC管理端" },
        { code: 4, codeName: "PC学员端" },
        { code: 6, codeName: "APP" },
        { code: 7, codeName: "凯迪拉克IQ" },
        { code: 8, codeName: "雪佛兰企微" },
        { code: 9, codeName: "别克企微" },
        { code: 10, codeName: "凯迪拉克企微" },
      ],
    },
    {
        title:"personId",
        name:"personId",
        tableItem: {
            width: 300
        },
    },
    {
      title:"token",
      name:"token",
      searchItem: {},
      tableItem: {
      },
    }

];

const templateConfig = {
    mainProps: {},
    content: {
        name: 'WizTableList',
        params: {
            columns,
            searchBarProps: {
                buttonSort: [],
                collapse: false,
                buttons: []
            },
            modalFormProps: {},
            dataTableProps: {
                rowKey: 'id',
                isScroll: true,
                bordered: false,
                paging: false,
                loading: false
            },
            rowOperateSort: ['disable'],
            rowOperateView: [
              {
                key: "disable",
                custom: true,
                params: { children: "踢出"},
                customOnClick: {
                  key: "action",
                  params: {
                    apiKey: "logout",
                    apiParams: {}
                  },
                  formatParams: (rows, record, filters, callback) => {
                    const content = `你是否确认将账号踢出？`;
                    WizModal.confirm({
                      title: '注意', content,
                      onOk: () => {
                        callback && callback({
                          token: record['token'],
                          id: record['id']
                        })
                      },
                      onCancel() {
                      }
                    });
                    return null
                  }
                }
              }
            ]
        }
    }
}

const apis = (platform) => {
  console.log("!!!!!",platform)
  return {
      list: {
        path: `AuthLoginLog/detailList`,
        payload: {
          key: `AuthLoginLog@detailList`,
          apiParams: { platform : platform }
        }
      },
      logout: {
        path: `AuthLoginLog/logOut`,
        payload: {
          key: `AuthLoginLog@logOut`,
          apiParams: {}
        }
      }
  }
  
}

let reduxTemplateConfig = (args) => {
  let { platform } = args;
  console.log("platform",platform)
  return {
    apis: apis(platform),
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export {reduxTemplateConfig, templateConfig};